import { Model } from "./../Model"

export class ModelCollection{

	constructor( private classRef:typeof Model ){
	}

}
